import React, { useCallback, useState,useMemo } from "react";
import { useDropzone } from "react-dropzone";
import {
  acceptStyle,
  baseStyle,
  focusedStyle,
  rejectStyle,
} from "./uploadCustomWatchListsStyles.js";
import "./filtersFileUpload.css";
import { UploadFile } from "../../../../../assets/index.js";

export const MAX_FILE_SIZE = 35 * 1024 * 1024;

const FiltersFileUpload = ({ field, form, accept }) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const clearError = () => setErrorMessage(null);

  const onDropRejected = (files) => {
    try {
      if (files) {
        const error = files[0].errors[0];
        setErrorMessage(error.code);
      }
    } catch (error) {
      console.error("something went wrong with file uploading/selecting");
    }
  };

  const onError = (error) => {};
  const onDrop = useCallback(
    (acceptedFiles) => {
      const acceptedFile = acceptedFiles[0];
      form.setFieldValue(field.name, acceptedFile);
    },
    [form]
  );

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({
      onDrop,
      multiple: false,
      accept,
      maxSize: MAX_FILE_SIZE,
      onError,
      onDropRejected: onDropRejected,
      onDropAccepted: clearError,
    });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  return (
    <div className="upload-filters-watch-list-multiple-search-uploader-container">
      <div className="upload-filters-watch-list-multiple-search-button-box">
        <div className="upload-filters-watch-list-multiple-search-label">
          {field.value && field.value.name
            ? field.value.name
            : "Choose file to upload"}
          <input {...getInputProps()} />
        </div>
        <div
          className="upload-filters-watch-list-multiple-search-choose-button"
          {...getRootProps()}
        >
          Browse Files
        </div>
      </div>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />

        <div className="d-flex flex-column ">
          <UploadFile />
          <p className="drag-label">
            {field.value ? (
              <span>{field.value.name}</span>
            ) : (
              "Drag and drop files here"
            )}
          </p>
        </div>
      </div>
      <span className="red">{errorMessage}</span>
    </div>
  );
};

export default FiltersFileUpload;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/search-watch-list-multiple-entries/filtersFileUpload/FiltersFileUpload.jsx